import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  containerForm: {
    maxWidth: 430,
    minWidth: 320,
    padding: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      padding: '40px 20px',
    },
  },
  title: {
    color: theme.screens.senhaPrimeiroAcesso?.title,
    fontFamily: theme.typography.fontFamilyTitle,
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
    paddingBottom: '8px',
  },
  text: {
    color: theme.screens.senhaPrimeiroAcesso?.text,
    fontFamily: theme.typography.descriptionFontFamily,
    fontSize: '14px',
    maxWidth: '300px',
    textAlign: 'left',
    paddingBottom: '32px',
  },
  cadastroImg: {
    width: '82px',
    height: '82px',
    paddingBottom: '16px',
  },
  fieldsGrid: {
    maxWidth: '100%',
  },
  fields: {
    paddingBottom: 32,
  },
  iconeVisibility: {
    color: theme.partnerComponents?.input?.icon,
  },
  information: {
    padding: '0 2px',
    color: theme.screens.senhaPrimeiroAcesso?.info,
    fontFamily: theme.typography.descriptionFontFamily,
    fontSize: 14,
    letterSpacing: -0.58,
    '& > span': {
      fontWeight: 700,
    },
    marginBottom: 15,
  },
  button: {
    color: theme.partnerComponents?.customButton?.text,
    fontFamily: theme.typography.fontFamilyTitle,
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.66px',
    textAlign: 'center',
    marginTop: theme.spacing(1),
    width: '158px',
    height: '48px',
    [theme.breakpoints.down('xs')]: {
      width: '90vw',
    },
  },
}));
